import { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { useGetExperiencesList } from "../experiences-list/get-experiences-list";
import { experienceKeys } from "../queryKeys";

import { getExperience } from "./get-experience";

export const usePrefetchPendingExperiences = async () => {
  const experiencesList = useGetExperiencesList({ category: "experiment" });
  const queryClient = useQueryClient();

  useEffect(() => {
    const fetchData = async () => {
      if (experiencesList.isSuccess) {
        await Promise.all(
          experiencesList.data.experiencesList?.map(async (exp) => {
            if (exp.status === "pending") {
              await queryClient.prefetchQuery({
                queryKey: experienceKeys.one(exp.id!),
                queryFn: async () => getExperience(exp.id!),
              });
            }
          })
        );
      }
    };

    void fetchData();
  }, [experiencesList.isSuccess, experiencesList.data]);
};
